import React from 'react';
import ga, { GACategories, GAActions } from '../../../../utils/googleAnalytics.utils';

export default function DownloadMyLayer({ url, setDownloadUrl }: { url: string; setDownloadUrl: Function }) {
  return (
    <div className='full-screen'>
      <div className='download-panel'>
        <button className='close esri-icon-close' onClick={() => setDownloadUrl('')}></button>
        <div className='header'>
          <p>Your file is ready</p>
        </div>
        <div className='container'></div>
        <div className='button-container'>
          <button className='green-button large' onClick={() => {
            setDownloadUrl('');
            ga.event(GACategories.DownloadButton, GAActions.Clicked, 'My Layer');
          }}>
            <a href={url} target='_blank' rel='noopener noreferrer'>
              <p>Click to download</p>
            </a>
          </button>
        </div>
      </div>
    </div>
  );
}
